<header>
  <div class="container nav" role="navigation" aria-label="Main">
    <a class="logo" routerLink="/">
      <img class="logo-mark"
        [src]="theme() === 'dark' ? 'assets/images/logo-white-low-res.png' : 'assets/images/logo-black-low-res.png'"
        alt="ahmo.photo logo" width="220">
    </a>
    <nav>
      <button class="menu-btn" [attr.aria-expanded]="menuOpen()" aria-controls="college-menu"
        (click)="toggleMenu()">Menu</button>
      <ul id="college-menu" role="menu" [class.open]="menuOpen()">
        <li role="none">
          <a role="menuitem" routerLink="/">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M3 12L12 3l9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 21V12h6v9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Home</span>
          </a>
        </li>
        <li role="none">
          <a role="menuitem" routerLink="/college-portfolio" aria-current="page">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M22 10v6M2 10l10-5 10 5-10 5-10-5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 12v5c3.33 2 8.67 2 12 0v-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>College Portfolio</span>
          </a>
        </li>
        <li class="menu-divider" role="separator" aria-hidden="true"></li>
        <li role="none">
          <button role="menuitem" type="button" class="icon-btn" (click)="toggleTheme()"
            [attr.aria-label]="theme() === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
            [title]="theme() === 'dark' ? 'Light theme' : 'Dark theme'">
            <span class="sr-only">Toggle theme</span>
            <svg *ngIf="theme() === 'dark'" width="18" height="18" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M12 3v2M12 19v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="2" />
            </svg>
            <svg *ngIf="theme() === 'light'" width="18" height="18" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" stroke="currentColor" stroke-width="2"
                fill="none" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</header>

<div class="spacer" aria-hidden="true"></div>

<section class="section">
  <div class="container">
    <h2>College Portfolio</h2>
    <p class="lead">Selected works from college photography courses.</p>

    <!-- Category Tabs -->
    <div class="tabs" role="tablist" aria-label="Portfolio categories">
      <button *ngFor="let cat of categories(); trackBy: trackByString" class="tab" role="tab" type="button"
        [class.active]="selectedCategory() === cat" [attr.aria-selected]="selectedCategory() === cat"
        (click)="selectCategory(cat)">{{ cat }}</button>
    </div>

    <div *ngIf="isLoading()" class="grid skeleton-grid" role="status" aria-live="polite" aria-busy="true">
      <span class="sr-only">Loading portfolio…</span>
      <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9]; let idx = index">
        <figure class="card skeleton" [ngClass]="(idx % 3 === 0) ? 'g-4' : 'g-3'">
          <div class="img" aria-hidden="true"></div>
          <figcaption class="overlay">
            <span class="line w-60" aria-hidden="true"></span>
            <span class="line w-40" aria-hidden="true"></span>
          </figcaption>
          <button aria-hidden="true" tabindex="-1"></button>
        </figure>
      </ng-container>
    </div>

    <div *ngIf="!isLoading() && loadError()" class="error" role="alert">
      {{ loadError() }}
    </div>

    <div class="grid" aria-live="polite" *ngIf="!isLoading() && !loadError()">
      <figure class="card" *ngFor="let item of pagedItems(); let i = index; trackBy: trackByIndex"
        [ngClass]="item.span">
        <div class="img-wrap">
          <img loading="lazy" decoding="async" [src]="item.src" [alt]="item.alt" (load)="onImgLoad($event)">
          <div class="img-spinner" aria-hidden="true"><span class="spinner"></span></div>
        </div>
        <figcaption class="overlay">
          <span class="title">{{ item.title }}</span>
          <span class="meta">{{ item.meta }}</span>
        </figcaption>
        <button (click)="openLightbox(i)" [attr.aria-label]="'Open ' + item.title"></button>
      </figure>
    </div>

    <!-- Load more UI -->
    <div *ngIf="!isLoading() && !loadError() && hasMore()" class="load-more-wrap">
      <button class="btn" type="button" (click)="loadMore()">Load more</button>
      <div #sentinel class="sentinel" aria-hidden="true"></div>
    </div>
  </div>
</section>

<footer class="footer">
  <div class="container"
    style="display:flex; justify-content:space-between; align-items:center; gap:1rem; flex-wrap:wrap;">
    <div>© {{ year }} ahmo.photo. All rights reserved.</div>
    <div class="social" aria-label="Social links">
      <a href="https://www.instagram.com/ahmophoto/" target="_blank" rel="noopener" aria-label="Instagram">Instagram</a>
      <span aria-hidden="true">·</span>
      <a href="https://www.behance.net/ahmophoto" target="_blank" rel="noopener" aria-label="Behance">Behance</a>
      <span aria-hidden="true">·</span>
      <a href="https://www.linkedin.com/in/ahmet-hadzijusufovic" target="_blank" rel="noopener" aria-label="LinkedIn">LinkedIn</a>
    </div>
  </div>
</footer>

<!-- Lightbox -->
<div *ngIf="lightboxOpen()" class="lightbox-backdrop" role="dialog" aria-modal="true" aria-label="Image viewer" (click)="closeLightbox()"
  style="position:fixed;inset:0;background:rgba(0,0,0,.92);display:grid;place-items:center;z-index:60;touch-action:pan-y;"
  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
  <div class="lightbox-stage">
    <button class="close-btn" (click)="closeLightbox(); $event.stopPropagation()" aria-label="Close viewer">×</button>
    <button *ngIf="displayedItems().length > 1" class="nav-arrow prev" (click)="prevImage(); $event.stopPropagation()"
      aria-label="Previous image">&#10094;</button>
    <div class="lightbox-frame" [class.animating]="animating()" [class.dir-next]="transitionDirection()==='next'"
      [class.dir-prev]="transitionDirection()==='prev'">
      <img class="lightbox-img" [class.is-loading]="lightboxLoading()" [src]="lightboxSrc()" alt="Expanded work"
        [attr.aria-describedby]="currentLightboxItem() ? 'lb-cap' : null">
      <div *ngIf="currentLightboxItem() as ci" id="lb-cap" class="lightbox-caption">
        <h3 class="lb-title">{{ ci.title }}</h3>
        <p class="lb-meta" *ngIf="ci.meta">{{ ci.meta }}</p>
        <p class="lb-cat" *ngIf="ci.category">{{ ci.category }}</p>
      </div>
    </div>
    <button *ngIf="displayedItems().length > 1" class="nav-arrow next" (click)="nextImage(); $event.stopPropagation()"
      aria-label="Next image">&#10095;</button>
    <div class="counter" aria-live="polite">{{ (lightboxIndex() ?? 0) + 1 }} / {{ displayedItems().length }}</div>
  </div>
</div>
